import { createMigration } from './utils';

export const migrationTo9_187 = createMigration({
    migrateVideo(video) {
        return video.withMutations(map => {
            map.get('slides').forEach((scene, i) => {
                map.setIn(['slides', i], this.migrateScene(scene));
            });
        });
    },

    migrateScene(scene) {
        const isCandidateGraphic = graphic => {
            return graphic.get('asMask') === true
                && graphic.get('level') === 'line'
                && (graphic.get('graphic') === 'box' || graphic.get('graphic') === 'boxBorder')
                && graphic.getIn(['shape', 'boxHeight']) === 'maxHeight';
        };

        const updateGraphicsOfChild = (map, graphicsPath) => {
            const graphics = map.getIn(graphicsPath);
            if (!graphics) {
                return;
            }
            graphics.forEach((graphic, ixGraphic) => {
                if (isCandidateGraphic(graphic)) {
                    map.setIn(graphicsPath.concat([ixGraphic, 'shape', 'boxHeight']), 'height');
                }
            });
        };

        return scene.withMutations(map => {
            map.get('children').forEach((child, ixChild) => {
                if (child.get('classType') === 'GraphicStyleTextAsset') {
                    updateGraphicsOfChild(map, ['children', ixChild, 'normalStyle', 'alphaGraphics']);
                    updateGraphicsOfChild(map, ['children', ixChild, 'normalStyle', 'colorGraphics']);
                }
            });

            map.get('subslides').forEach((subslide, ixSubslide) => {
                subslide.get('children').forEach((child, ixChild) => {
                    if (child.get('classType') === 'GraphicStyleTextAsset') {
                        updateGraphicsOfChild(map, ['subslides', ixSubslide, 'children', ixChild, 'normalStyle', 'alphaGraphics']);
                        updateGraphicsOfChild(map, ['subslides', ixSubslide, 'children', ixChild, 'normalStyle', 'colorGraphics']);
                    }
                });
            });
        });
    },
});
